'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'cloud-rainbow';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f73e';
var svgPathData = 'M302.6 146.4C359.8 76.6 446.7 32 544 32l32 0 0-32-32 0c-113.7 0-214.6 55.2-277.2 140.2 5.3 3.6 10.3 7.6 15.1 11.8 6.7-2.4 13.6-4.3 20.7-5.7zM485.6 257.9C502.3 246.6 522.4 240 544 240l32 0 0-32-32 0c-32.8 0-62.8 11.6-86.3 30.9 .8 2.6 1.6 5.2 2.2 7.9 9 2.9 17.6 6.6 25.7 11.1zm-67.3-79.6C453.2 151.7 496.8 136 544 136l32 0 0-32-32 0c-58.3 0-111.7 20.8-153.3 55.3 10 5.2 19.2 11.6 27.5 19zM96 272c0-44.2 35.8-80 80-80 35.3 0 65.3 22.9 75.9 54.7l10.7 32 18-28.5c9.9-15.7 27.5-26.1 47.4-26.1 30.9 0 56 25.1 56 56l0 45.2 19.2-3.9c4.1-.8 8.4-1.3 12.8-1.3 35.3 0 64 28.7 64 64l0 64-448 0 0-64c0-30.9 22-56.8 51.2-62.7L96 318.7 96 272zm80-112c-61.9 0-112 50.1-112 112l0 21.5C26.7 306.6 0 342.2 0 384l0 96 512 0 0-96c0-53-43-96-96-96l0-8c0-48.6-39.4-88-88-88-21.7 0-41.5 7.9-56.9 20.9-19.8-31.7-55-52.9-95.1-52.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;